import { apiAuth, apiResponseType } from ".";
import type { ProductsFilters } from "@/App/Products/filters";

const isNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

/**
 * Serializa os filtros da listagem no formato aceito pelo backend:
 * `name`, `lottery_id[]` (multiselect) e `min_<coluna>` / `max_<coluna>`
 * para os intervalos numéricos.
 */
export const buildProductsFilterParams = (
  filters: ProductsFilters = {}
): URLSearchParams => {
  const searchParams = new URLSearchParams();

  if (filters.name?.trim()) {
    searchParams.append("name", filters.name.trim());
  }

  filters.lottery_id?.forEach((lotteryId) => {
    if (lotteryId !== undefined && lotteryId !== null && lotteryId !== "") {
      searchParams.append("lottery_id[]", String(lotteryId));
    }
  });

  Object.entries(filters.ranges ?? {}).forEach(([column, range]) => {
    if (!range) return;
    if (isNumber(range.min)) searchParams.append(`min_${column}`, String(range.min));
    if (isNumber(range.max)) searchParams.append(`max_${column}`, String(range.max));
  });

  return searchParams;
};

/**
 * Listagem paginada. A resposta traz o paginator de sempre acrescido de
 * `limits`: os limites reais (min/max) de cada coluna numérica filtrável.
 */
export const getProductsData = (
  page: number = 1,
  filters: ProductsFilters = {}
): apiResponseType => {
  const searchParams = buildProductsFilterParams(filters);
  searchParams.append("page", String(page));

  return apiAuth.get(`product-classifications?${searchParams.toString()}`);
};

export const registerProductsData = (data) =>
  apiAuth.postForm("/product-classifications/store", data) as apiResponseType;
export const deleteProductsData = (tenid: string) =>
  apiAuth.delete(`product-classifications/${tenid}/destroy`) as apiResponseType;
export const updateProductsData = (tenid: string, data) =>
  apiAuth.put(
    `product-classifications/${tenid}/update`,
    data
  ) as apiResponseType;

export const getShowProducts = (tenid: string) =>
  apiAuth.get(`product-classifications/${tenid}/show`) as apiResponseType;

export const searchProductsData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`product-classifications?name=${params.name}`);

export const setStatusProducts = (tenid: string) =>
  apiAuth.put(
    `product-classifications/${tenid}/toggle-status`
  ) as apiResponseType;

export const getSelectProducts = (params?: {
  nameProduct?: string;
  lottery_id?: string;
}) => {
  const searchParams = new URLSearchParams();

  if (params?.nameProduct) {
    searchParams.append("name", params.nameProduct);
  }

  if (params?.lottery_id) {
    searchParams.append("lottery_id", params.lottery_id);
  }

  return apiAuth.get(
    `product-classifications/select?${searchParams.toString()}`
  ) as apiResponseType;
};
